import { render, staticRenderFns } from "./AttendanceDialog.vue?vue&type=template&id=672e2fee"
import script from "./AttendanceDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttendanceDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports